import { Teacher } from './teacher'
import { Clazz } from './clazz'
import { Student } from './student'
import { IGradeUniversity } from './grade'

export enum Winter2023ConfigCategory {
  SAFELESSON = 'online_course',
  PELESSON = 'homework',
  QAQRSKILLS = 'challenge',
  MIX = 'inter_subject_practice',
}

export interface IWinter2023Config {
  id: string
  type: Winter2023ConfigCategory
  title: string
  subtitle: string
  icon: string
  icon_thumb: string
  multiple: false
  options: {
    id: string
    title: string
    description: string
    type: 'detailed' | 'custom'
    tags: string[]
    subjects?: string[]
  }[]
  groups: {
    option_ids: string[]
    title: string
  }[]
}

export interface IWinter2023LessonsQurey {
  task_id: string
  option_id: string
  grade_no: number
  start_date: string | Date
  end_date: string | Date
}

export interface IWinter2023Form {
  id: string | null
  title: string
  start_date: string | Date
  end_date: string | Date
  class_ids: number[]
  tasks: {
    task_id: string
    options: {
      option_id: string
      title?: string
      subjects?: string[]
      description?: string
    }[]
  }[]
}

export interface IWinter2023Preview {
  id: string
  title: string
  start_date: string | Date
  end_date: string | Date
  teacher: {
    teacher_id: string
    user_id: string
    teacher_name: string
    brief_phone: string
    head_img_url: string
  }
  class_ids: number[]
  tasks: {
    task_id: string
    options: {
      option_id: string
      title?: string
      subjects?: string[]
      description?: string
    }[]
  }[]
}

export interface IPaperDetail {
  title: string
  paper_type: number
  total_score: number
  single_countdown_seconds: number
  questions: IPaperQuestion[]
}
export interface IPaperQuestionOptions {
  id: string
  content: string
  is_right: boolean
  seq: number
}

export interface IPaperQuestion {
  id: string
  category: string
  question_type: number
  subject: string
  score: number
  seq: number
  difficulty_level: string
  explanation: string
  options: IPaperQuestionOptions[]
}

export interface IChanlengeItem {
  name: string
  item_type: number
  item_type_str: string
  item_biz_no: string
  level_no: number
  difficulty_level: string
  description: string
}

export enum ExamQuestionType {
  TestByPractice = 'testByPractice',
  TestByExam = 'testByExam',
}

export interface ChallengeConfig {
  name: string
  challenge_id: string
  challenge_type: number
  challenge_type_str: 'SPECIAL_EXERCISE' | 'KNOWLEDGE'
  data: IPaperDetail[] | IChanlengeItem[]
}

export interface IStatusOfWinter2023Awards {
  vacation_plan_created: boolean
  course_received: boolean
  gift_pack_received: boolean
  target_of_invitee: number
  invited: number
  total_gift_packs_today: number
  remaining_gift_packs_today: number
  tracking_company_name: string
  tracking_no: string
}

export interface ITrainingListItem {
  name: string
  class_vo_list: Clazz[]
  grade_scope_list: IGradeUniversity[]
  teacher_vo: Teacher
  start_datetime: Date
  end_datetime: Date
  group_id: string
  paper_id: string
}

export interface IChallengeRepoItem {
  id: string
  name: string
  challenge_tye: number
  challenge_type_str: string
  total_level_no: number
  img_url: string
}

export interface IClazzStaticSummary {
  students_count: number
  completion_count: number
  uncompleted_count: number
  completion_rate: string
  challenge_class_id: null | number
  class_vo: Clazz | null
  challenge_id: string
  paper_id: string
}

export interface IStudentStaticSummary {
  student_vo: Student
  class_vo: Clazz
  challenge_user_score_id: string
  current_level_no: number
  total_level_no: number
  star_score: string
  completion_status: string
}

export interface IStudentPrize {
  reward_item_id: string
  name: string
  min_day?: number
  min_star?: number
  pic: string
}

export interface IStudentChallengeRecord {
  student_vo: Student
  class_vo: Clazz
  score: string
  item_records: IChallengeRecords[]
}

export interface IChallengeRecords {
  challenge_item_user_score_id: string
  level_no: number
  name: string
  item_type: number
  drill_records: IChallengeDrillRecord[]
  max_paper_record: IChallengeMaxPaperRecord
}

export interface IChallengeDrillRecord {
  name: string
  drill_record_id: string
  duration: number
  star_score: number
  ai_detect_label: string
  time: string
}

export interface IChallengeMaxPaperRecord {
  correct_quantity: number
  wrong_quantity: number
  undo_quantity: number
  total_quantity: number
  star_score: number
  questions: IStudentChallengeRecordQuestion[]
}

export interface IStudentChallengeRecordQuestion {
  subject: string
  status: number
  explanation: string | null
  user_option_ids: string[]
  right_option_ids: string[]
  options: IStudentQuestionOptions[]
}

export interface ICreateExamOrChallengeForm {
  paper_id: string
  paper_type: string
  name: string
  start_datetime: Date
  end_datetime: Date | null
  question_score: number | null
  class_id_list: number[]
  grade_ids: number[]
}

export interface IPaperItem {
  paper_id: string
  title: string
  paper_type: 1 | 2
  author: string
}

export interface IPaperExamStaticInfo {
  exam: ITeacherPaperExamItem
  class_total_summary: IPaperExamStaticInfoSummary
  class_summary_list: IPaperExamStaticInfoSummary[]
}

export interface ITeacherPaperExamItem {
  online_exam_id: string
  paper_id: string
  snapshot_paper_id: string
  title: string
  start_datetime: Date
  end_datetime: Date
  status: string
  class_vo_list: Clazz[]
  grade_scope_list: IGradeUniversity[]
  teacher_vo: Teacher
}

export interface ITeacherPaperExamItemUpdate {
  online_exam_id: string
  name: string
  start_datetime: Date
  end_datetime: Date
}

export interface IPaperExamStaticInfoSummary {
  students_count: number
  attending_count: number
  un_start_count: number
  completion_count: number
  class_vo: Clazz
  avg_score: number
  online_exam_class_id: string
}

export interface IExamSummaryItem {
  online_exam_id: string
  paper_id: string
  snapshot_paper_id: string
  title: string
  start_datetime: string
  end_datetime: string
  status: string
  class_vo_list: Clazz
  teacher_vo: Teacher
}

export interface IExamStudentStaticInfo {
  exam: ITeacherPaperExamItem
  class_total_summary: IPaperExamStaticInfoSummary
  student_summary_list: IExamStudentStaticItem[]
}

export interface IExamStudentStaticItem {
  online_exam_class_id: string
  question_count: number
  answer_count: number
  paper_status: 0 | 1 | 2
  correct_quantity: number
  score: number
  student_vo: Student
  class_vo: Clazz
}

export interface IExamStudentPaper {
  title: string
  correct_quantity: number
  wrong_quantity: number
  undo_quantity: number
  total_quantity: number
  star_score: number
  questions: IStudentChallengeRecordQuestion[]
  class_vo: Clazz
  student_vo: Student
}

export interface IPaperQuestion {
  id: string
  category: string
  question_type: number
  subject: string
  score: number
  seq: number
  difficulty_level: string
  options: IPaperQuestionOptions[]
}

export interface IStudentQuestionOptions {
  id: string
  content: string
  is_right: boolean
}

export interface IStudentQuestion {
  subject: string
  status: number
  explanation: string
  user_option_ids: string[]
  right_option_ids: string[]
  options: IStudentQuestionOptions[]
}

export interface IWinter2023Stat {
  overview: {
    sum_duration: number
    sum_completed: number
    avg_duration: number
    sum_record_count: number
  }
  task_stats: {
    task: {
      id: string
      type: Winter2023ConfigCategory
      title: string
      subtitle: string
      icon: string
      icon_thumb: string
    }
    sum_record_count: number
    sum_completed: number
    avg_duration: number
    completion_rate: number
    avg_score: number
  }[]
}

export interface IDatetime {
  time: string
  date: Date
}

export interface IYearTopRank {
  school_name: string
  locate: string
  drill_number: number
}

export interface IYearTopRankMine {
  ranking: number
  school_name: string
  locate: string
  drill_number: number
}

export interface IWinter2023UserContributionForm {
  name: string
  url: string
  source: string
}

export interface IWinter2023UserContribution {
  name: string
  url: string
  heat: string
}

export interface IWinter2023UserContributionMine {
  name: string
  url: string
  heat: number
  ranking: number
}

export interface IWinter2023MixSubjectsItem {
  id: string
  title: string
  start_date: string
  end_date: string
  classes: Clazz[]
  teacher: Teacher
  online: boolean
}

export interface IWinter2023MixSubjectClazzSummary {
  student_count: number
  completed: number
  unstarted: number
}

export interface IWinter2023MixSubjectClazzItem {
  clazz: Clazz
  student_count: number
  completed: number
}

export interface IWinter2023MixSubjectStudentItem {
  student: Student
  gender: string
  progress: number
}
